import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import App from './App';

import 'moment/dist/locale/de';
import 'dayjs/locale/de';
import './i18n.js';

import { installGoogleTranslateCompat } from './utils/google-translate-compat';
import { initializeLanguage } from './utils/language';

// Must run before React mounts — browser translators mutate text nodes and
// otherwise crash reconciler removeChild/insertBefore (e.g. date pickers).
installGoogleTranslateCompat();

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    sendDefaultPii: true,
  });
}

// Initialize language from localStorage
initializeLanguage();

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
